import { render, staticRenderFns } from "./ReportViewDetailContratoJugadores.vue?vue&type=template&id=1a5058ca&scoped=true&"
import script from "./ReportViewDetailContratoJugadores.vue?vue&type=script&lang=js&"
export * from "./ReportViewDetailContratoJugadores.vue?vue&type=script&lang=js&"
import style0 from "./ReportViewDetailContratoJugadores.vue?vue&type=style&index=0&id=1a5058ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5058ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VSnackbar,
  VTooltip,
})
